import { Injectable } from '@angular/core';
import { rdsapStorageHeatersPcdbData994 } from 'src/rdsap/config/rdsap-storage-heaters-pcdb-data.config';

@Injectable({
  providedIn: 'root'
})
export class PcdfSearchManualService {
  private pcdbStorageHeatersData = rdsapStorageHeatersPcdbData994;

  viewPcdbStorageHeatersData(): any[] {
    return this.pcdbStorageHeatersData.data[391].filter(item => {
      if(item.status === '0') { return item; }
    })
  }
}
